const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

const textValuesUI = {
  // added for ui
  type: uiTypes.TEXT, //UI Types
  validation: [], //UI Validation
  list: false,
  read: true,
  create: true,
  edit: true,
};
const obj = {
  tableName: "about_us",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false, //for enabiling comments on view and edit
  references: [],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "hero_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
      },
    },
    {
      name: "hero_image",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },

    {
      name: "pointerTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "pointerSubtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "pointers",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "text",
            type: "text", //image , text
          },
          {
            name: "priority",
            type: "text", //image , text
          },
          {
            name: "image",
            type: "image", //image , text
          },
        ], // incas
      },
    },
    {
      name: "aboutBoxImage",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "aboutTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
      },
    },
    {
      name: "aboutSubTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
      },
    },
    {
      name: "aboutBoxsummary",
      type: types.STRING,
      validation: [validatorTypes.url, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
        validation: [validatorTypes.string, validatorTypes.required],
      },
    },
    {
      name: "counters",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text
          },
          {
            name: "counters",
            type: "text", //image , text
          },
          {
            name: "priority",
            type: "text", //image , text
          },
        ], // incas
      },
    },
    {
      name: "ourTeamTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "ourTeamSubtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "teams",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "name",
            type: "text", //image , text
          },
          {
            name: "designation",
            type: "text", //image , text
          },
          {
            name: "linkedin",
            type: "text", //image , text
          },
          {
            name: "priority",
            type: "text", //image , text
          },
          {
            name: "photo",
            type: "image", //image , text
          },
          {
            name: "description",
            type: "textarea", //image , text
          },
        ], // incas
      },
    },

    {
      name: "keyPointsTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "keyPointsSubtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "key_points",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea, key_value, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value, key_value
          },
          {
            name: "vector_art",
            type: "image", //image , text, textarea, key_value, key_value
          },
          {
            name: "description",
            type: "textarea", //image , text, textarea, key_value, key_value
          },
        ], // incas
      },
    },
    {
      name: "ourProcessTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "ourProcessSubtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "steps",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea, key_value, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value, key_value
          },
          {
            name: "vector_art",
            type: "image", //image , text, textarea, key_value, key_value
          },
          {
            name: "description",
            type: "textarea", //image , text, textarea, key_value, key_value
          },
        ], // incas
      },
    },
    {
      name: "galleryTitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "gallerySubtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "galleryDescription",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "buttonText",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "videoUrl",
      type: types.STRING,
      validation: [validatorTypes.url, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "aboutPageBanner",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },

    {
      name: "contactPageBanner",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },

    {
      name: "propertyPageBanner",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },

    // {
    //   name: "images",
    //   type: types.JSON,
    //   isArray: true,
    //   allowNull: true,
    //   validation: [validatorTypes.arrayUrl, validatorTypes.optional],
    //   ui: {
    //     // added for ui
    //     type: uiTypes.MULTI_IMAGE, //UI Types
    //     validation: [], //UI Validation
    //     list: false,
    //     read: true,
    //     create: true,
    //     edit: true,
    //   },
    // },
    {
      name: "enabled",
      type: types.BOOLEAN,
      isArray: false,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.SWITCH, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
